<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
  >
    <circle
      v-if="!noCircle"
      data-name="楕円形 188"
      cx="12"
      cy="12"
      r="12"
      :style="{ fill: color }"
    />
    <path
      v-if="!noCircle"
      data-name="長方形 3041"
      transform="translate(3.529 3.529)"
      style="fill: none"
      d="M0 0h16.941v16.941H0z"
    />
    <path
      data-name="パス 4654"
      d="M687.643 249.706a1.058 1.058 0 0 1-.748-.311l-4.387-4.386a1.059 1.059 0 0 1 1.5-1.5l3.481 3.491 5.7-8.334a1.058 1.058 0 1 1 1.748 1.194l-6.415 9.388a1.059 1.059 0 0 1-.775.457c-.038-.005-.071.001-.104.001z"
      transform="translate(-676.656 -231.953)"
      :style="{ fill: checkColor }"
    />
  </svg>
</template>

<script>
export default {
  name: 'CheckIconSVG',
  props: {
    color: {
      type: String,
      default: '#0075c2',
    },
    checkColor: {
      type: String,
      default: '#fff',
    },
    size: {
      type: String,
      default: '24px',
    },
    noCircle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
